import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Header from "components/headers/light.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import { Container } from "components/misc/Layouts";

export default () => {
  const Subheading = tw.span`tracking-wider text-sm font-medium`;
  const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
  const HighlightedTextInverse = tw.span`bg-gray-100 text-primary-500 px-4 transform -skew-x-12 inline-block`;
  const Description = tw.span`inline-block mt-8`;
  const SingleColumn = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;
  const imageCss = tw`rounded-4xl`;
  return (
    <AnimationRevealPage>
      <Header />
      <Hero
        heading={<>Thursdays 7-9pm <HighlightedText>at Penweddig School</HighlightedText></>}
        description="From 24th of November 2022 we will be fencing from the sports hall of Penweddig School."
        imageSrc="./img/3628827_d2dbf018_original.jpg"
        imageCss={imageCss}
        imageAlt="Penweddig School © Copyright Ian Capper"
        imageSub={<>© Copyright Ian Capper and licensed for reuse under <a href="http://creativecommons.org/licenses/by-sa/2.0/">this Creative Commons Licence.</a></>}
        imageDecoratorBlob={true}
        primaryButtonText="See Calendar"
        watchVideoButtonText="Message From "
      />
      <Container>
        <SingleColumn>
          <iframe
            width="100%"
            height="450"
            style={{border:0}}
            loading="lazy"
            allowfullscreen
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2433.8307160716863!2d-4.0674772!3d52.4097442!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x486f765223196e41%3A0x36037001dbed7039!2sYsgol%20Gyfun%20Gymunedol%20Penweddig!5e0!3m2!1sen!2suk!4v1739309772968!5m2!1sen!2suk">
          </iframe>
        </SingleColumn>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
}
